import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../shared/providers/base-provider';
import { AuthNotifier } from './auth-notifier';
import { AuthState } from './auth-state';

/**
 * AuthProvider — solo conecta el notifier con el state.
 * Toda la reactividad y la lógica de sesión viven en AuthNotifier.
 */
@Injectable({ providedIn: 'root' })
export class AuthProvider extends BaseProvider<AuthNotifier, AuthState> {
  constructor() {
    super(AuthNotifier);
  }
}